<template>
    <form class="options" autocomplete="off" v-if="definition">
        Display Field(s)
        <div class="df-chooser">
            <div class="selected-df" :id="`display-field-${id}`">
                <div class="name">{{ selectedDisplayFieldName }}</div>
                <span class="icon far fa-chevron-down"></span>
            </div>
            <elem-dropdown :triggerSelector="`#display-field-${id}`">
                <template v-slot:default="slotProps">
                    <selectable-list
                        :items="schemaItems"
                        :value="feature.dataElementDisplayField"
                        :active="slotProps.isOpen"
                        :onSelect="
                            (item) =>
                                update('dataElementDisplayField', item.value)
                        "
                    />
                </template>
            </elem-dropdown>
        </div>
        <!-- <div>
            <div class="checkbox-wrapper">
                <input
                    type="checkbox"
                    :id="`enable-for-filler-${id}`"
                    :checked="feature.dataElementAlwaysEditable"
                    @change="
                        (e) =>
                            update(
                                'dataElementAlwaysEditable',
                                e.target.checked
                            )
                    "
                />
                <label :for="`enable-for-filler-${id}`"
                    >Enable for Filler</label
                >
            </div>
        </div> -->
    </form>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { strings } from '../../../utils';

    export default {
        name: 'PropTabContactSearchSettings',
        data() {
            return {
                id: strings.random(5),
                ...mapGetters({}),
            };
        },
        props: {
            feature: {
                required: true,
            },
        },
        computed: {
            definition() {
                return this.$store.getters['dataElements/getDefinitions'].find(
                    (def) => def.unique_name === 'contact'
                );
            },
            schemaItems() {
                if (!this.definition) return [];

                return this.definition.schema.reduce(
                    (acc, item) => {
                        if (!item.linkable) return acc;
                        acc.push({ name: item.label, value: item.name });
                        return acc;
                    },
                    [
                        { name: 'First Name Last Name', value: 'fullname' },
                        { name: 'Last Name, First Name', value: 'fullnameReversed' }
                    ]
                );
            },
            selectedDisplayFieldName() {
                return this.schemaItems.find(
                    (item) => item.value === this.feature.dataElementDisplayField
                ).name;
            },
        },
        methods: {
            update(prop, val) {
                this.$store.commit('form/updateFeature', {
                    feature: this.feature,
                    updates: {
                        [prop]: val,
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .df-chooser {
        display: flex;
        margin-bottom: 0.5em;
    }

    .selected-df {
        @include border;
        @include border-radius-small;
        user-select: none;
        padding: 0.25em 0.5em;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        .name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .icon {
            margin-left: 0.25em;
        }
    }
</style>
